import { VatText } from "@/components/VatText.tsx";
import { useThemeProps } from "@/modules/theme/useTheme.ts";
import { Trans } from "@lingui/react/macro";

//
// Components for text pieces that can be customized per-theme
//

export function InvoicesTitle() {
    const { invoiceAltTranslations } = useThemeProps();
    return invoiceAltTranslations?.invoicesTitle ?? <Trans>Invoices</Trans>;
}

export function TopUpInvoicesTitle() {
    const { invoiceAltTranslations } = useThemeProps();
    return (
        invoiceAltTranslations?.topupInvoicesTitle ?? (
            <Trans comment="Invoices for billing account top-ups">Top-up invoices</Trans>
        )
    );
}

export function UnpaidAmountTooltip() {
    const { invoiceAltTranslations } = useThemeProps();
    const vatSymbol = <VatText />;
    return (
        invoiceAltTranslations?.unpaidAmountTooltip ?? (
            <Trans>Total of all unpaid invoices. Including {vatSymbol}.</Trans>
        )
    );
}
